<template>
  <v-form ref="form" class="form pa-3">
    <p>{{ $t("manage-records.reprocess-transmissions-about") }}</p>
    <p>{{ $t("manage-records.reprocess-transmissions-warning") }}</p>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="6">
        <DateInput
          :date="start_time"
          :label="$t('manage-records.start-time')"
          @update="val => (start_time = val)"
          :rules="[rules.requiredForDate, backEndValidation('start_time')]"
        ></DateInput>
      </v-col>
      <v-col cols="6">
        <DateInput
          :date="end_time"
          :label="$t('manage-records.end-time')"
          @update="val => (end_time = val)"
          :rules="[rules.requiredForDate, backEndValidation('end_time')]"
        ></DateInput>
      </v-col>
    </v-row>
    <v-btn color="primary mr-3" v-on:click="save()" :loading="loading">
      <v-icon left>mdi-reload</v-icon>
      {{ $t(`manage-records.reprocess-transmissions`) }}
    </v-btn>
  </v-form>
</template>

<script>
import { rules } from "../../../mixins/rules";
import DateInput from "../../../common/inputs/DateInput";
export default {
  name: "ReprocessTransmissions",
  components: { DateInput },
  mixins: [rules],
  data: () => ({
    loading: false,
    start_time: "",
    end_time: ""
  }),
  methods: {
    save() {
      this.clearBackEndErrors();
      if (this.$refs.form.validate()) {
        this.loading = true;
        let params = {
          start_time: this.start_time,
          end_time: this.end_time,
          project_id: this.$route.params.project_id,
          meter_units: [this.$route.params.id]
        };
        this.$store
          .dispatch("projectMeteringStore/transmissionStore/reprocess", {
            params,
            errorHandler: this.errorHandler.bind(this, () => {
              this.$refs.form.validate();
            })
          })
          .finally(() => (this.loading = false));
      }
    }
  }
};
</script>
